import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon } from '@zillow/constellation';
import { getWholeDollars } from '../../utils/zhl-calculator.js';
import { getRemainingMonthlyPayment } from './DTICalculator.utils.js';

var circleSvg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 10 10"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "5",
  r: "4"
}));
var DTICostBreakdownTable = function DTICostBreakdownTable(_ref) {
  var debtsOut = _ref.debtsOut,
    monthlyIncome = _ref.monthlyIncome,
    mortgagePayment = _ref.mortgagePayment;
  return /*#__PURE__*/React.createElement(Table, {
    appearance: "barebones",
    "aria-label": "Debt to income cost breakdown table",
    size: "lg",
    alignments: ['left', 'right']
  }, /*#__PURE__*/React.createElement(Table.Body, null, /*#__PURE__*/React.createElement(Table.Row, null, /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontColor: "orange500"
  }, circleSvg), " Total monthly debts"), /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, getWholeDollars(debtsOut))), /*#__PURE__*/React.createElement(Table.Row, null, /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontColor: "blue600"
  }, circleSvg), " Mortgage payment"), /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, getWholeDollars(mortgagePayment))), /*#__PURE__*/React.createElement(Table.Row, null, /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    fontColor: "brand"
  }, circleSvg), " Remaining mo. income"), /*#__PURE__*/React.createElement(Table.Cell, {
    style: {
      padding: '8px 0 0'
    }
  }, getWholeDollars(getRemainingMonthlyPayment(monthlyIncome, debtsOut, mortgagePayment))))));
};
DTICostBreakdownTable.propTypes = process.env.NODE_ENV !== "production" ? {
  debtsOut: PropTypes.number,
  monthlyIncome: PropTypes.number,
  mortgagePayment: PropTypes.number
} : {};
var DTICostBreakdownTable$1 = DTICostBreakdownTable;

export { DTICostBreakdownTable$1 as default };
